import { useLingui } from '@lingui/react/macro';

import { FilterDate, FilterDateValue } from '@/design_system/Filters/FiltersMenu/FilterDate';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import { DateRangeValue } from '@/design_system/InputDate/InputDateRange';
import IconCalendarEdit from '@/icons/CalendarEdit.svg';
import { formatDateRange } from '@/utils/date';

import { useFilters } from '../FiltersState';
import { useDateOptions } from '../utils';

export const FiltersCreatedAt = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    createdAt: { createdAt, setCreatedAt },
  } = useFilters();

  const baseCreatedAtOptions = useDateOptions();

  const baseValue = baseCreatedAtOptions.find(({ id }) => id === createdAt.id);

  const toggleDate = (value: FilterDateValue, customValue?: DateRangeValue): void => {
    if (value === 'custom' && customValue) {
      setCreatedAt({ id: value, ...customValue });

      return;
    }
    const currentSelected = baseCreatedAtOptions.find((date) => date.id === value);

    if (currentSelected && currentSelected.value) {
      const { start, end } = currentSelected.value;

      setCreatedAt({ id: value, start, end });
    } else {
      setCreatedAt({ id: 'all', start: null, end: null });
    }
  };

  const { start, end } = createdAt;
  const customValue = createdAt.id === 'custom' && start && end ? { start, end } : undefined;

  if (tag) {
    if (start === null || end === null) {
      return null;
    }

    const currentValue =
      baseValue && baseValue.id !== 'custom'
        ? baseValue.label
        : `${formatDateRange(new Date(start), new Date(end), { dateStyle: 'medium' })}`;

    return (
      <FilterDate
        icon={<IconCalendarEdit />}
        label={t({ id: 'requests.filters.createdAt.label', message: 'Creation date' })}
        value={createdAt.id}
        customValue={customValue}
        onChange={toggleDate}
        button={
          <FilterTag
            label={t({ id: 'requests.filters.createdAt.label', message: 'Creation date' })}
            value={currentValue}
            onClear={() => setCreatedAt({ id: 'all', start: null, end: null })}
          />
        }
      />
    );
  }

  return (
    <FilterDate
      icon={<IconCalendarEdit />}
      label={t({ id: 'requests.filters.createdAt.label', message: 'Creation date' })}
      value={createdAt.id}
      customValue={customValue}
      onChange={toggleDate}
    />
  );
};
